export function safeAjax(ajaxOptions) {
    const deferredAjax = $.Deferred();
    shell
        .getTokenDeferred()
        .done(function (token) {
        ajaxOptions.headers = {
            ...ajaxOptions.headers,
            __RequestVerificationToken: token
        };
        $.ajax(ajaxOptions)
            .done(function (data, textStatus, jqXHR) {
            validateLoginSession(data, textStatus, jqXHR, deferredAjax.resolve);
        })
            .fail(deferredAjax.reject);
    })
        .fail(function () {
        deferredAjax.rejectWith(this, arguments);
    });
    return deferredAjax.promise();
}
function validateLoginSessionForFetch(response, callback) {
    const respondedJsonHeader = response.headers.get("x-responded-json");
    if (respondedJsonHeader) {
        const respondedJson = JSON.parse(respondedJsonHeader);
        if (respondedJson &&
            respondedJson.status &&
            (respondedJson.status === 401 || respondedJson.status === 403)) {
            redirectToLogin();
        }
    }
    callback(response);
}
export function safeFetch(url, fetchOptions) {
    const deferredAjax = $.Deferred();
    shell
        .getTokenDeferred()
        .done(function (token) {
        fetchOptions.headers = {
            ...fetchOptions.headers,
            __RequestVerificationToken: token
        };
        return fetch(url, fetchOptions)
            .then(response => {
            validateLoginSessionForFetch(response, deferredAjax.resolve);
        })
            .catch(error => {
            deferredAjax.reject(null, null, error);
        });
    })
        .fail(function () {
        deferredAjax.rejectWith(this, arguments);
    });
    return deferredAjax.promise();
}
